import Vue from 'vue';
import { PRODUCT_ROUTES } from '@/constants/routes';
import config from '@/config/config.json';

class ProductService {
	constructor() {}

  async getByFamilyName(familyName, isMana) {
    const url = `${config.apiUrl}${PRODUCT_ROUTES.BASE_URL}/${PRODUCT_ROUTES.FAMILY}`;
    const response = await Vue.prototype.$http.get(url, {
      params: {
        familyName: familyName,
        isMana: isMana
      }
    });

    return response.data;
  }

  getOptionValues(fieldName) {
    let arr = [];
    Vue.localStorage.get('listProduct').forEach(element => {
      if (arr.indexOf(element[fieldName]) === -1) {
        arr.push(element[fieldName]);
      }
    });
  
    return arr;
  }

  getFamiliesForTab() {
    return Vue.localStorage.get('productFamilies').map(item => {
      return {
        name: item,
        isActive: false
      };
    });
  }

  getProduct(productId) {
    let product = {};
    Vue.localStorage.get('listProduct').forEach(p => {
      if (p.productId === productId.trim()) {
        product = p;
      }
    });
  
    return product;
  }

  getProducts() {
    return Vue.localStorage.get('listProduct');
  }

  getProductIdName(id) {
    return Vue.localStorage.get('listProduct').find(p => p.id === id).productId;
  }

  getProductsIdNames(sectionName) {
    let productIds = [];

    if (sectionName != 'All products') {
      Vue.localStorage.get('listProduct').forEach(product => {
        if (
          productIds.indexOf(product.productId) === -1 &&
          product.sectionName === sectionName
        ) {
          productIds.push(product.productId);
        }
      });
    } else {
      Vue.localStorage.get('listProduct').forEach(product => {
        if (productIds.indexOf(product.productId) === -1) {
          productIds.push(product.productId);
        }
      });
    }
  
    return productIds;
  }

  getClusterNames(sectionName) {
    let clusterNames = [];

    if (sectionName != 'All products') {
      Vue.localStorage.get('listProduct').forEach(product => {
        if (
          clusterNames.indexOf(product.cluster) === -1 &&
          product.sectionName === sectionName
        ) {
          clusterNames.push(product.cluster);
        }
      });
    } else {
      Vue.localStorage.get('listProduct').forEach(product => {
        if (clusterNames.indexOf(product.cluster) === -1) {
          clusterNames.push(product.cluster);
        }
      });
    }
  
    return clusterNames;
  }

  getFamilyProducts() {
    return Vue.localStorage.get('familyProducts');
  }

  getProductFamilies() {
    return Vue.localStorage.get('productFamilies');
  }

  setLocalProduct(product) {
    Vue.localStorage.set('product', product);
  }

  getLocalProduct() {
    return Vue.localStorage.get('product');
  }
}

export default new ProductService();
